import React, { useState, useEffect } from 'react'
import { IonContent, IonPage } from '@ionic/react';
import LayoutGap from '../../layouts/LayoutGap';
import { RouteComponentProps, useHistory } from 'react-router';

import Description from './Description';
import Toolbar from '../../layouts/Toolbar';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import './EventDetailPage.css'
import Updates from './Updates';

interface Props extends RouteComponentProps<{
    event_id: string,
    type: string
}> { }

const EventDetailPage: React.FC<Props> = ({ match }) => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const [title, setTitle] = useState("")
    const [subtitle, setSubTitle] = useState("")
    const [activeComponent, setActiveComponent] = useState(null as any)

    useEffect(() => {
        if (match.params.type == 'desc') {
            setTitle("توضیحات")
            setActiveComponent(<Description content={history.location.state as any} />)
        } else if (match.params.type == 'updates') {
            setTitle("گزارش ها")
            setSubTitle((history.location.state as any)[0]?.date)
            setActiveComponent(<Updates data={history.location.state as any} changeSubTitle={changeSubTitleHandler} />)
        }
    }, [])

    const changeSubTitleHandler = async (subTitle: string) => {
        setSubTitle(subTitle);
    }

    return (
        <IonPage className="campaign-detail">
            <Toolbar title={title} subTitle={subtitle} hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                {activeComponent}
            </IonContent>
        </IonPage>
    )
}

export default EventDetailPage